<script setup lang="ts">
import { getPcoHelpContent } from '@/config/resourcesPcoHelpCopy';
import { usePcoPageHelpStore } from '@/stores/pcoPageHelpStore';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

const pcoHelp = usePcoPageHelpStore();
const { helpKey } = storeToRefs(pcoHelp);
const content = computed(() => getPcoHelpContent(helpKey.value));
</script>

<template>
    <div class="d-flex align-center justify-space-between pa-4">
        <div class="d-flex align-center min-width-0 pr-2">
            <v-icon color="primary" class="mr-2 flex-shrink-0">mdi-help-circle-outline</v-icon>
            <span class="text-h6 text-truncate">{{ content.panelTitle }}</span>
        </div>
        <v-btn icon variant="text" aria-label="Fechar ajuda" @click="pcoHelp.closeDrawer()">
            <v-icon>mdi-close</v-icon>
        </v-btn>
    </div>
    <v-divider />

    <div class="pa-4 text-body-2 text-medium-emphasis pco-page-help-body">
        <p class="mb-4">{{ content.intro }}</p>

        <template v-for="(sec, idx) in content.sections" :key="idx">
            <p class="mb-2 font-weight-medium text-body-2" style="color: rgb(var(--v-theme-on-surface))">{{ sec.title }}</p>
            <p v-if="sec.paragraph" class="mb-3">{{ sec.paragraph }}</p>
            <ul v-if="sec.bullets?.length" class="mb-4 pl-4">
                <li v-for="(b, j) in sec.bullets" :key="j" class="mb-1">{{ b }}</li>
            </ul>
        </template>

        <v-alert
            v-for="(a, i) in content.alerts"
            :key="i"
            :type="a.type"
            variant="tonal"
            density="compact"
            class="text-caption mb-3"
        >
            {{ a.text }}
        </v-alert>
    </div>
</template>

<style scoped>
.pco-page-help-body {
    max-height: calc(100vh - 90px);
    overflow-y: auto;
    overflow-x: hidden;
}
</style>
